import EncryptedTransferInteraction from "@/models/EncryptedTransferInteraction";
import store from "@/store";
import { AxiosResponse, AxiosRequestConfig } from 'axios';
import BaseAdapter from './base';

export default class InteractionAdapter extends BaseAdapter {

  request(options: AxiosRequestConfig): any {
    //Overwrite auth if logged in
    if (store.getters.isLoggedIn) {
      options.auth = {
        username: store.state.account.username,
        password: store.state.account.masterHash,
      };
    }
    return super.request(options);
  }


  public async addInteraction(uploadId: string, interaction: EncryptedTransferInteraction): Promise<boolean> {
    const url = `/uploads/${uploadId}/interaction`;
    const result: AxiosResponse = await this.request({
      method: 'post',
      url,
      data: interaction,
    });
    return result.data;
  }

  public async getInteractionsForUpload(uploadId: string): Promise<EncryptedTransferInteraction[]> {
    const url = `/uploads/${uploadId}/interaction`;
    const result: AxiosResponse = await this.request({
      method: 'get',
      url,
    });
    return result.data as EncryptedTransferInteraction[];

  }
}
